import isBrowser from './isBrowser';

export default function isDev() {
  const { hostname } = isBrowser() ? new URL(window.location) : {};
  return hostname === 'localhost';
}
